import { Injectable } from '@angular/core';
import {PortalServiceUpdater} from '../../form/model/portal.service.updater';
import {Observable} from 'rxjs/Observable';
import {ApiService} from '../../../../core/service/api.service';

@Injectable()
export class VnaCampaignActionService implements PortalServiceUpdater{

    constructor(private api: ApiService) { }

    savePortalService(criteria: Object, configPart: string, aliasSrv: string, data: Object): Observable<any> {

        return this.api.customPatch('vna/service-campaign/' + criteria['camp_pk'] + '/action/' + criteria['action_pk'] + '/service-config?segment=' + configPart + '&service_pk=' + criteria['service_pk'] + '&portal_pk=' + criteria['portal_pk'] + '&alias_srv=' + aliasSrv, data);
    }

    getExternalCallbacks(criteria: Object): Observable<any>{
         return Observable.of([]);
    }

    findMergedActionCampaign(pkAction: number): Observable<any> {
        return this.api.get('vna/service-campaign-action/' + pkAction);
    }

    findActionReportings(pkAction: number): Observable<any> {
        return this.api.get('vna/service-campaign-action/' + pkAction + '/report');
    }

    createReport(pkAction: number): Observable<any> {
        return this.api.post('vna/service-campaign-action/' + pkAction + '/report', {});
    }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/config/vna-campaign/services/vna-campaign-action.service.ts